<template>

    <Sidebar v-model:visible="filtervisible" position="right" class="webfilter">
        <template #header>
            <div class="d-flex justify-space-between align-items-center border-bottom pb-2">
                <p class="compo-heading">Filter</p>
                <i class="pi pi-times blue-txt me-2" @click="closeside()"></i>
            </div>
        </template>
        <div>
            <slot name="filterslot"></slot>
        </div>
    </Sidebar>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
export default defineComponent({
    props: {
        filtervisible: {
            type: Boolean,
            default: false,
        },
    },
    setup(props, { emit }) {
        const filtervisible = ref(false);
        const closeside = () => {
            emit("closeside");
        }
        return {
            filtervisible,
            closeside
        }
    }
})

</script>

<style>
.webfilter .p-sidebar-header {
    padding: 10px 0px;
}

@media only screen and (max-width: 545px) {
    .p-sidebar-right {
        z-index: 1101 !important;
    }

    .p-sidebar-bottom {
        z-index: 1102 !important;
    }
}

@media only screen and (min-width: 545px) {
    .p-sidebar-bottom {
        z-index: 1101 !important;
    }

    .p-sidebar-right {
        z-index: 1102 !important;
    }

}
</style>